import { default as about0CAIIN5ZxLMeta } from "/app/apps/client/pages/about.vue?macro=true";
import { default as faqHeh50eQrqmMeta } from "/app/apps/client/pages/faq.vue?macro=true";
import { default as indexrPW0hKRbDqMeta } from "/app/apps/client/pages/index.vue?macro=true";
import { default as cartybpJeBXBFqMeta } from "/app/apps/client/pages/order/cart.vue?macro=true";
import { default as checkouthLL42CXkBmMeta } from "/app/apps/client/pages/order/checkout.vue?macro=true";
import { default as paymentcWmmAllg4MMeta } from "/app/apps/client/pages/order/payment.vue?macro=true";
import { default as _91id_93WuXaAMKJ1zMeta } from "/app/apps/client/pages/order/receipt/[id].vue?macro=true";
import { default as orderu7vh0FIMCaMeta } from "/app/apps/client/pages/order.vue?macro=true";
import { default as privacy_45policyqz5uURSa0pMeta } from "/app/apps/client/pages/privacy-policy.vue?macro=true";
import { default as public_45offerUTFy39pNGxMeta } from "/app/apps/client/pages/public-offer.vue?macro=true";
import { default as _91product_936KQkH6KdrsMeta } from "/app/apps/client/pages/shop/[kind]/[product].vue?macro=true";
import { default as indexYcfGF6pKkmMeta } from "/app/apps/client/pages/shop/[kind]/index.vue?macro=true";
import { default as shopAIuKKFkj7TMeta } from "/app/apps/client/pages/shop.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/app/apps/client/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/app/apps/client/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexrPW0hKRbDqMeta || {},
    component: () => import("/app/apps/client/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "order",
    path: "/order",
    meta: orderu7vh0FIMCaMeta || {},
    component: () => import("/app/apps/client/pages/order.vue").then(m => m.default || m),
    children: [
  {
    name: "order-cart",
    path: "cart",
    component: () => import("/app/apps/client/pages/order/cart.vue").then(m => m.default || m)
  },
  {
    name: "order-checkout",
    path: "checkout",
    component: () => import("/app/apps/client/pages/order/checkout.vue").then(m => m.default || m)
  },
  {
    name: "order-payment",
    path: "payment",
    meta: paymentcWmmAllg4MMeta || {},
    component: () => import("/app/apps/client/pages/order/payment.vue").then(m => m.default || m)
  },
  {
    name: "order-receipt-id",
    path: "receipt/:id()",
    component: () => import("/app/apps/client/pages/order/receipt/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/apps/client/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "public-offer",
    path: "/public-offer",
    component: () => import("/app/apps/client/pages/public-offer.vue").then(m => m.default || m)
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/app/apps/client/pages/shop.vue").then(m => m.default || m),
    children: [
  {
    name: "shop-kind-product",
    path: ":kind()/:product()",
    component: () => import("/app/apps/client/pages/shop/[kind]/[product].vue").then(m => m.default || m)
  },
  {
    name: "shop-kind",
    path: ":kind()",
    component: () => import("/app/apps/client/pages/shop/[kind]/index.vue").then(m => m.default || m)
  }
]
  }
]